import HTTP from "../HTTP";
import Jsona from "jsona";
import documentsHelper from "@/API/helpers/documents";

const dataFormatter = new Jsona();

export default {
  async index(account_id) {
    try {
      let results = await HTTP.normal.get(
        `/accounts/${account_id}/documents?page%5Bsize%5D=50`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os documentos!";
    }
  },

  async show(document_id) {
    try {
      let res = await HTTP.normal.get(
        `/documents/${document_id}?include=account`
      );

      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o documento!";
    }
  },

  async create(payload, account) {
    try {
      let data = documentsHelper.createDocumentBody(payload, account);

      await HTTP.normal.post(`/documents`, data);
    } catch (e) {
      throw "Ocorreu um erro ao criar o documento!";
    }
  },

  async update(payload, document_id) {
    try {
      let data = documentsHelper.updateDocumentBody(payload, document_id);

      return await HTTP.normal.put(`/documents/${document_id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o documento!";
    }
  },

  async approveDocument(document_id) {
    try {
      return await HTTP.normal.post(
        `/management/documents/${document_id}/approve-document`,
        {}
      );
    } catch (e) {
      throw "Ocorreu um erro ao tentar aprovar o documento!";
    }
  },

  async setDocumentReadyToProcess(document_id) {
    try {
      return await HTTP.normal.post(
        `/management/documents/${document_id}/ready-to-process`,
        {}
      );
    } catch (e) {
      throw "Ocorreu um erro ao tentar enviar o documento para análise!";
    }
  },

  async setDocumentPendingApproval(document_id) {
    try {
      return await HTTP.normal.post(
        `/management/documents/${document_id}/pending-approval`,
        {}
      );
    } catch (e) {
      throw "Ocorreu um erro ao tentar enviar o documento para análise interna!";
    }
  },

  async checkDocumentOnDataAssuranceService(
    document_report_id,
    document_external_id
  ) {
    try {
      return await HTTP.normal.post(
        `document_data_assurance/webhooks/document_data_assurance`,
        { report: document_report_id, uuid: document_external_id }
      );
    } catch (e) {
      throw "Ocorreu um erro ao atualizar junto ao CAF!";
    }
  },

  async sendDocumentImage(payload) {
    try {
      let response = await HTTP.cloudinary.post("/upload", payload);
      let document_url = response.data.secure_url;

      return document_url;
    } catch (e) {
      throw "Ocorreu um erro ao tentar salvar a imagem!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/documents.js